import {parseResponse} from 'hono/client';
import type {RpcClient} from './rpc-client';
import type {AudioTranscriber, AudioTranscriberOptions} from '@/shared/ui/blocks/audio-transcriber';

const MIME_TO_EXTENSION: Record<string, string> = {
  'audio/webm;codecs=opus': 'webm',
  'audio/webm': 'webm',
  'audio/ogg;codecs=opus': 'ogg',
  'audio/ogg': 'ogg',
  'audio/mp4': 'mp4',
};

const DEFAULT_EXTENSION = 'webm';

/**
 * Hono RPC adapter for the shared {@link AudioTranscriber} contract.
 * Sends the recorded audio as raw multipart bytes to `POST /v1/transcribe`.
 */
export class RpcAudioTranscriber implements AudioTranscriber {
  constructor(private readonly rpcClient: RpcClient) {}

  async transcribe(audio: Blob, options?: AudioTranscriberOptions): Promise<string> {
    const extension = MIME_TO_EXTENSION[audio.type] ?? DEFAULT_EXTENSION;
    const file = new File([audio], `audio.${extension}`, {type: audio.type});

    try {
      const dto = await parseResponse(
        this.rpcClient.transcribe.$post({form: {file}}, {init: {signal: options?.signal}}),
      );
      return dto.text;
    } catch (cause) {
      throw new Error('Transcription failed.', {cause});
    }
  }
}
